import { CapacityCostDataPoint } from "./costGraphsSectionHelpers";

type CostGraphTooltipProps = {
    readonly active?: boolean;
    readonly payload?: ReadonlyArray<{ payload: CapacityCostDataPoint }>;
    readonly selectedPoint: number | null;
    readonly costLabel: string;
    readonly showCapacity: boolean;
    readonly shouldShowCharging: boolean;
};

export const CostGraphTooltip: React.FC<CostGraphTooltipProps> = ({
    active,
    payload,
    selectedPoint,
    costLabel,
    showCapacity,
    shouldShowCharging
}) => {
    if (!active || !payload || payload.length === 0) {
        return null;
    }

    const data = payload[0].payload;
    const isSelected = selectedPoint === data.xValue;

    if (isSelected) {
        return (
            <div className="CostGraphsSection-tooltip">
                <p className="CostGraphsSection-tooltip-text--bold">
                    {shouldShowCharging ? "Charging" : "Energy"} Size:{" "}
                    {data.xValue} MW
                </p>
                {showCapacity && (
                    <p className="CostGraphsSection-tooltip-text">
                        Capacity Size: {data.capacitySize} MW
                    </p>
                )}
                <p className="CostGraphsSection-tooltip-text">
                    Constraints: {data.constraints}
                </p>
                <p className="CostGraphsSection-tooltip-text">
                    {costLabel}: ${Math.round(data.cost).toLocaleString()}
                </p>
                <p className="CostGraphsSection-tooltip-text--last">
                    {costLabel} per MW: $
                    {Math.round(data.costPerMW).toLocaleString()}/MW
                </p>
            </div>
        );
    }

    return (
        <div className="CostGraphsSection-tooltip CostGraphsSection-tooltip--simple">
            <p className="CostGraphsSection-tooltip-text--simple">
                {data.xValue} MW
            </p>
        </div>
    );
};
